import { encode as base64_encode } from "base-64";
import { postApi } from "../components/Utility";
import config from "../config";
import { action, makeObservable, observable } from "mobx";

class AssignDriverToUserStore {
    total = 0;
    loading = false;
    driverGroupDrivers = [];
    driverList = [];
    rootStore;

    constructor(rootStore) {
        makeObservable(this, {
            driverGroupDrivers: observable,
            driverList: observable,
            addData: action,
            getAllUserDrivers: action,
            toAssignDriverToUser: action,

        });
        this.rootStore = rootStore;
    }

    async addData(data) {
        console.log("data", data);
        var postData = data;
        const base64Input = await base64_encode(JSON.stringify(postData));
        var response = await postApi
            .getClient()
            .post("index.php?c=user&a=usergroup", "postData=" + base64Input);
        console.log(response);
        return response;
    }

    async getAllUserDrivers({ companyId, userId }) {

        console.log(companyId, userId)
        // get getDriverAssignedToUser
        var postData = { companyId: companyId, userId: userId };

        var response = await postApi
            .getClient("")
            .get(config.NodeUrl + "/driver/getDriverAssignedToUser", {
                // .get(config.NodeUrl + "/driver/getDriverAssignedToUser", {
                params: postData,
            });
        console.log("response", response);
        this.assignedDriverList = response?.data?.data?.driverIds;
        this.assignedGroup = response?.data?.data?.groups[0]?.drgId

        return response.data?.data;


    }
    async getDriveGroup({ companyId }) {
        this.loading = true;

        var postData = { companyId: companyId };

        var response = await postApi
            .getClient("")
            .get(config.NodeUrl + "/driver/getDriverGroup", {
                // .get(config.NodeUrl + "/driver/getDriverGroup", {
                params: postData,
            });
        this.loading = false;

        this.driverGroupDrivers =
            response?.data?.data;//?.DeviceGroupData[0]?.devicegroups;
        // console.log(this.driverGroupDrivers)
        this.loading = false;
    }

    async getGroupofDrivers({ companyId, drgId }) {
        this.loading = true;

        var postData = { companyId: companyId, drgId: drgId };

        var response = await postApi
            .getClient("")
            // .get(config.NodeUrl + "/driver/getGroupwiseDriver", {
            .get(config.NodeUrl + "/driver/getGroupwiseDriver", {
                // .get(config.NodeUrl + "/driver/getDriverGroup", {
                params: postData,
            });
        this.loading = false;
        // debugger
        this.driverList = response?.data?.data;//?.DeviceGroupData[0]?.devicegroups;
        // console.log(this.driverGroupDrivers)
        this.loading = false;
    }

    toAssignDriverToUser = async (data) => {
        console.log("data", data);
        // var postData = data;
        var response = await postApi
            .getClient("")
            .post(config.NodeUrl + "/driver/assignDrivertoUser",
                // .get(config.NodeUrl + "/driver/assignDrivertoUser", {
                data,
            );
        console.log(response);
        return response;
    }




}

export default AssignDriverToUserStore;
